<template>
  <div class="AssignmentBannerDialog">
    <BannerDialog :open="is_open">

      <!-- Autocomplete Beauftragter -->
      <div class="field-label">Beauftragter</div>
      <v-autocomplete
                v-model="val_beauftragter"
                :items="items_beauftragter"
                item-text="name"
                item-value="id"
                solo
                flat
                class="mb-1 AutoComplete"
                return-object
        >

        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content v-text="data.item"></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-avatar width="32" min-width="32" height="32" size="32">
              <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
              <PersonIconDark v-if="!data.item.imageSrc"/>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>

        <template v-slot:selection="data">
          <v-list-item-avatar width="32" min-width="32" height="32" size="32">
            <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
            <PersonIconDark v-if="!data.item.imageSrc"/>
          </v-list-item-avatar>
          {{ data.item.name }}
        </template>
      </v-autocomplete>

      <!-- Autocomplete Bearbeiter -->
      <span class="disabled">Bearbeiter</span>
      <v-autocomplete
                v-model="val_bearbeiter"
                :items="items_bearbeiter"
                item-text="name"
                item-value="id"
                solo
                flat
                class="mb-1 AutoComplete"
                return-object
                disabled
        >

        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content v-text="data.item"></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-avatar width="32" min-width="32" height="32" size="32">
              <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
              <PersonIconDark v-if="!data.item.imageSrc"/>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>

        <template v-slot:selection="data">
            <v-list-item-avatar width="32" min-width="32" height="32" size="32">
              <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
              <PersonIconDark v-if="!data.item.imageSrc"/>
            </v-list-item-avatar>
          {{ data.item.name }}
        </template>
      </v-autocomplete>

      <!-- AutoComplete Pipeline -->
      <span>Pipeline</span>
      <v-autocomplete
                v-model="val_pipeline"
                :items="items_pipeline"
                item-text="name"
                item-value="id"
                solo
                flat
                class="mb-1 AutoComplete"
                return-object
        >

        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content v-text="data.item"></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-avatar width="32" min-width="32" height="32" size="32">
              <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
              <PersonIconDark v-if="!data.item.imageSrc"/>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-subtitle>{{ data.item.group.join(', ') }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>

        <template v-slot:selection="data">
          <v-list-item-avatar width="32" min-width="32" height="32" size="32">
            <img :src="data.item.imageSrc" v-if="data.item.imageSrc" />
            <PersonIconDark v-if="!data.item.imageSrc"/>
          </v-list-item-avatar>
          {{ data.item.name }}
        </template>
      </v-autocomplete>

      <!-- Buttons -->
      <template v-slot:action>
        <v-row class="mt-2">
          <v-col cols="6" class="py-0">
            <ButtonCancel @click="cancel"/>
          </v-col>
          <v-col cols="6" class="py-0 text-right">
            <ButtonPrimary @click="assignLead">
              <template v-slot:text>
                {{ $t('buttons.assign') }}
              </template>
            </ButtonPrimary>
          </v-col>
        </v-row>
      </template>

    </BannerDialog>
  </div>
</template>

<script>
import BannerDialog from "@/components/form/templates/BannerDialog";
import {ref, toRefs} from "@vue/composition-api";
import ButtonPrimary from "@/components/buttons/templates/ButtonPrimary";
import ButtonCancel from "@/components/buttons/templates/ButtonCancel";
import PersonIconDark from "@/components/icons/PersonIconDark.vue";

export default {
  name: 'AssignmentBannerDialog',
  components:{
    BannerDialog,
    ButtonPrimary,
    ButtonCancel,
    PersonIconDark
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    items_beauftragter:{
      type: Array
    },
    items_bearbeiter:{
      type: Array
    },
    items_pipeline:{
      type: Array
    },
  },
  setup(props, {emit}){
    const is_open = toRefs(props).open;

    const val_beauftragter = ref(null);
    const val_bearbeiter = ref(null);
    const val_pipeline = ref(null);

    const cancel = () => {
      reset();
      console.log('cancel assign');
      emit('cancel');
    }

    const reset = () => {
      //reset data
      val_beauftragter.value = null;
      val_bearbeiter.value = null;
      val_pipeline.value = null;
    }

    const assignLead = () => {

      if(val_beauftragter.value && val_pipeline.value)
      {
        let assign_data = {
          assignee_id: val_beauftragter.value.id,
          assignee_name: val_beauftragter.value.name,
          editor_id: val_bearbeiter.value ? val_bearbeiter.value.id : null,
          editor_name: val_bearbeiter.value ? val_bearbeiter.value.name : null,
          pipeline_id: val_pipeline.value.id,
          pipeline_name: val_pipeline.value.name,
          pipeline_groups: val_pipeline.value.group
        };

        reset();

        //send event
        emit('assign-lead', assign_data);
      }
      else{
        console.log('Beauftragter + Pipeline müssen selektiert sein.');
      }
    }

    return {is_open, cancel, assignLead,
            val_pipeline, val_beauftragter, val_bearbeiter};
  }
}
</script>

<style scoped lang="scss">
.AssignmentBannerDialog {
  .field-label {
    color: map-get($grey, 'darken-1');
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    padding-bottom: 8px;
  }

  .v-btn {
    box-shadow: none;

    &.grey {
      border: 1px solid map-get($grey, 'base');
    }

    &.green {
      border: 1px solid $primary;
    }
  }
}
</style>

<style lang="scss">
//override globally
.v-menu__content {
  z-index: 1100 !important;

  /* Dropdown list*/
  .v-list {
    padding: 0;

    .v-list-item {
      &::before {
        opacity: 0.2;
      }

      + .v-list-item {
        border-top: 1px solid map-get($grey, 'lighten-3');
      }
    }
  }
}

// Mouse Over for list items
#app.v-application .v-menu__content .v-list .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: white !important;

  &:hover {
    color: map-get($green, 'darken-1') !important;
  }
}

// Styling for active list item
#app.v-application .v-menu__content .v-list .theme--light.v-list-item.v-list-item--active:not(.v-list-item--disabled) {
  background-color: map-get($grey, 'lighten-4');

  &::before {
    opacity: 0;
  }

  &:hover {
    color: map-get($green, 'darken-1') !important;

    &::before {
      opacity: 0.2;
    }
  }
}

.AutoComplete.v-input--is-disabled {
  opacity: 0.5;
}

.AssignmentBannerDialog {
  .AutoComplete {
    .v-input__slot {
      border: 1px solid map-get($grey, 'lighten-1');

      /* Dropdown arrow */
      .v-input__append-inner {
        background: map-get($grey, 'lighten-1');
        margin: -22px -12px -22px 0;
        height: 46px;
        width: 48px;
      }

      /* Dropdown icon */
      .v-input__icon {
        height: 42px;

        .mdi-menu-down {
          font-size: 32px;

          &::before {
            content: "\F0140";
            color: white;
          }
        }
      }
    }
  }
}

.v-menu__content {
  .v-list-item {
    padding-top: 8px;
    padding-bottom: 8px;

    .v-list-item__content {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.v-avatar {
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: map-get($grey, 'lighten-blue-1');
  border-radius: 50%;
  margin-top: 0;
  margin-left: 2px !important;
  margin-bottom: 0;

  .person-icon-dark {
    margin: auto;
    height: 50%;
    width: 50%;

    .a {
      stroke: $white;
    }
  }
}
</style>
